import React from "react";
import s from "./TopPageInfoBlock.module.css";
import img from "../../assets/img/InvoicesPage/chart_full.png";

type Props = {
    text:string
    subText:string
    iconImage?:string
}

const TopPageInfoBlock:React.FC<Props> = ({ text, subText, iconImage }) => {
  return (
    <div className={s.infoBlock}>
      <div className={s.infoBlockText}>{text}</div>
      {subText && (
        <span className={s.infoBlockSubText}>{subText}</span>
      )}
      <img src={iconImage ? iconImage : img} alt={text} />
    </div>
  );
};

export default TopPageInfoBlock;
